import { createFileRoute } from '@tanstack/react-router';

import { SupplierCatalogPage } from '@/features/supplier/catalog-page';

export const Route = createFileRoute('/_app/supplier/$orgId/catalog')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierCatalogPage {...params} />;
}
